import RestX from 'highered-utils/restx';
import ActionScheduler from '~/utils/actionScheduler';
import i18n from '~/localization/i18n';
import router from '~/router';
import URLS from '../URLS';
import DialogService from './DialogService';
import { SchoolVerificationState } from './SchoolService';
export default class BackgroundProcesses {
    static scheduleVirtualEventPromotion() {
        console.info('Scheduling virtual event promotion');
        const name = 'virtualEventPromotion';
        const key = `backgroundprocess-${name}`;

        const hasAlreadyDoneAction = localStorage.getItem(key);
        if (hasAlreadyDoneAction) {
            return;
        }

        // Do not run after 10th of May 2023
        const now = new Date();
        const end = new Date('2023-05-10');
        if (now > end) {
            return;
        }

        return ActionScheduler.schedule({
            name: name,
            duration: 5000,
            action: () => {
                DialogService.openVirtualEventPromotion('0792049e-5f8b-40ba-a943-d2f6ed83d5f3');
                ActionScheduler.cancel(name);
                localStorage.setItem(key, true);
            },
        });
    }

    static scheduleLogInPopup() {
        return ActionScheduler.schedule({
            name: 'logInPopUp',
            duration: 20000,
            durationHandler: (i, prev) => (prev * 1.5 >= 45000 ? 45000 : prev * 1.5), // y = 1.5x with cap on 45 seconds
            action: () => {
                const logInModule = RestX.getInterfaces().logInModule;

                if (!logInModule.isLoggedIn()) {
                    logInModule.setHelperText(
                        i18n.t('general.dialogs.helperTexts.logInToAccessMoreFeatures')
                    );
                    if (logInModule.prevPagePopupOpened() === router.currentRoute.path) {
                        logInModule.setShouldOpenOnNewPage(true);
                        logInModule.setPrevPagePopupOpened(null);
                    } else if (!logInModule.shouldOpenOnNewPage()) {
                        logInModule.setOpen(true);
                        logInModule.setPrevPagePopupOpened(router.currentRoute.path);
                    }
                }

                this.stopLogInPopup();
            },
        });
    }

    static clearLogInPopup() {
        return ActionScheduler.cancel('logInPopUp');
    }

    static stopLogInPopup() {
        ActionScheduler.stop('logInPopUp');
    }

    static restartLogInPopup() {
        return ActionScheduler.start('logInPopUp');
    }

    static schoolVerificationPing;

    static startVerificationPing() {
        if (this.schoolVerificationPing) {
            return;
        }

        var shouldContinue = true;
        this.schoolVerificationPing = setInterval(
            () => {
                if (shouldContinue) {
                    RestX.getInterfaces()
                        .university.connection.get({
                            forceUpdate: true,
                        })
                        .then(res => {
                            if (
                                res.data.length === 0 ||
                                !res.data.find(val => val.state === SchoolVerificationState.pending)
                            ) {
                                this.shouldContinue = false;
                                this.stopVerificationPing();
                            }
                        });
                }
            },
            3000,
            true
        );

        setTimeout(() => this.stopVerificationPing(), 5 * 60 * 1000);
    }

    static stopVerificationPing() {
        if (!this.schoolVerificationPing) {
            return;
        }

        clearInterval(this.schoolVerificationPing);
        this.schoolVerificationPing = null;
    }
}

function addEvent(obj, evt, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false);
    } else if (obj.attachEvent) {
        obj.attachEvent('on' + evt, fn);
    }
}

addEvent(document, 'mouseout', e => {
    e = e ? e : window.event;
    var from = e.relatedTarget || e.toElement;
    if (from && from.nodeName != 'HTML') {
        // stop your drag event here
        // for now we can just use an alert
        return;
    }

    // Don't proceed on certain pages
    const blacklist = [
        URLS.redirect,
        URLS.recoverPassword,
        URLS.recoverUser,
        URLS.emailVerification,
        URLS.activateUser,
    ].filter(route => route === router.currentRoute.path);
    if (blacklist.length >= 1) {
        return;
    }

    const logInModule = RestX.getInterfaces().logInModule;
    if (!logInModule.isLoggedIn() && !logInModule.hasOpenedOnWindowOut()) {
        logInModule.setHelperText(i18n.t('general.dialogs.helperTexts.logInToAccessMoreFeatures'));

        logInModule.setOpen(true);
        logInModule.setPrevPagePopupOpened(router.currentRoute.path);
        logInModule.setHasOpenedOnWindowOut(true);
        BackgroundProcesses.stopLogInPopup();
    }
});
